import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  list: {},
  statusList: [],
  ecommStatusList: {
    groupList: [],
    statusList: {}
  },
  tabData: {},
  pending: false
});

export function setOrderList(state, data) {
  return state.merge({
    pending: false,
    list: data.docs.reduce((obj, doc) => {
      obj[doc.orderId] = doc; // eslint-disable-line no-param-reassign
      return obj;
    }, {})
  });
}

export function setOrderTabName(state, data, from) {
  const jsState = state.toJS();
  const { tabData } = jsState;
  if (!tabData[data.tabName]) {
    tabData[data.tabName] = {};
  }
  if (from) {
    tabData[data.tabName].orders = tabData[data.tabName].orders.concat(
      data.docs
    );
  } else {
    tabData[data.tabName].orders = data.docs;
  }
  tabData[data.tabName].from = data.from;
  tabData[data.tabName].limit = data.limit;
  tabData[data.tabName].count = data.count;
  return state.merge({ pending: false, tabData });
}

export function updateOrder(state, data) {
  const jsState = state.toJS();
  const { tabData, list } = jsState;
  if (typeof data !== 'undefined') {
    // remove old instance of order and push it in after
    Object.keys(tabData).forEach(key => {
      const orders = tabData[key].orders.filter(item => {
        if (item.orderId === data.orderId) {
          return false;
        }
        return true;
      });
      tabData[key].orders = orders;
    });
    if (!tabData[data.tabName]) {
      tabData[data.tabName] = { orders: [], from: '', limit: 100, count: 1 };
    }
    tabData[data.tabName].orders.push(data);

    list[data.orderId] = data;
  }
  return state.merge({ pending: false, tabData, list });
}

export function setStatusList(state, statusList) {
  return state.merge({ pending: false, statusList });
}

export function setEcommStatusList(state, ecommStatusList) {
  return state.merge({ pending: false, ecommStatusList });
}

export function setPendingSelf(state, pending = true) {
  return state.set('pending', !!pending);
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'ORDER_LIST':
      return setOrderList(state, action.data);

    case 'ORDER_LIST_TABNAME':
      return setOrderTabName(state, action.data, action.from);

    case 'ORDER_UPDATE':
      return updateOrder(state, action.data);

    case 'ORDER_STATUS_LIST':
      return setStatusList(state, action.statusList);

    case 'ORDER_ECOMM_STATUS_LIST':
      return setEcommStatusList(state, action.statusList);

    case 'ORDER_PENDING':
      return setPendingSelf(state, action.pending);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/orders.js